import axios, { AxiosRequestConfig, AxiosResponse } from 'axios'
import { decrypt, getNativeInfo, handleV3Response, determineApiVersionFromUrl, requestV3Headers, isMegaUrl, extractBaseUrl, EUFY_MEGA_APPLICATION_NAME, getAppHeaderName } from '@docs/common'
import { omit } from 'lodash'
import Cookies from 'js-cookie'

export interface ResponseData<T> {
  code: number
  msg: string
  data: T
}

/** -100 作为打断的 Code */
const CANCELED_CODE = -100

async function request<T>(
  url: string,
  config?: Omit<AxiosRequestConfig, 'url'>,
  extra?: { [k: string]: number | string | boolean }
) {

  let _headers = {
    'Web-Country':Cookies.get('web_country'),
    ...config?.headers,
  }

  const appName = await getAppHeaderName()

  if(appName === EUFY_MEGA_APPLICATION_NAME){
    _headers['X-Auth-Token'] = Cookies.get('token')
    _headers['App-Name'] =  Cookies.get('app_name')
    _headers['App-Country'] = Cookies.get('country')
    _headers['Gtoken'] = Cookies.get('gtoken')
    _headers['Model-Type'] = 'PHONE'
  }


  if (!extra?.ignoreAuthToken) {
    const { token } = await getNativeInfo()
    _headers['X-Auth-Token'] = token
  }

  // v3 mega接口 针对请求头进行处理
  if (await determineApiVersionFromUrl(url) === 'v3' || (appName === EUFY_MEGA_APPLICATION_NAME && isMegaUrl(url || ''))) {
     const domain = appName === EUFY_MEGA_APPLICATION_NAME ? extractBaseUrl(url || '') : ''
    const { v3_headers } = await requestV3Headers(config || {}, domain)
    _headers = { ..._headers, ...v3_headers }
  }

  const requestConfig = {
    url,
    withCredentials: false,
    ...config,
    headers: _headers,
  }
  return axios
    .request<any, AxiosResponse<T>>(requestConfig)
    .then(async (response: any) => {
      const url = response.config.url
      let _data = response.data
      if (await determineApiVersionFromUrl(url) === 'v2') {
        // 如果返回的是字符串 则解密
        if (typeof response === 'string') {
          response = await decrypt({ type: 0, data: response as string })
        }
        if (typeof _data === 'string') {
          _data = await decrypt({ type: 0, data: _data as string })
        } else if (typeof _data?.data === 'string') {
          // start_ai_generated
          _data = {
            ...omit(_data, ['data']),
            data: await decrypt({ type: 0, data: _data?.data as string }),
          }
          // end_ai_generated
        }
      }
      // v3 针对返回数据解密
      if (await determineApiVersionFromUrl(url) === 'v3' || isMegaUrl(response?.config?.url || '')) {
        const appName = await getAppHeaderName()
        const domain = appName === EUFY_MEGA_APPLICATION_NAME ? extractBaseUrl(response?.config?.url || '') : ''
        _data = await handleV3Response(response,domain)
      }
      console.log(`${response.config.url}`, _data)
      return _data
    })
    .catch(thrown => {
      if (axios.isCancel(thrown)) {
        // 避免被判断为 void 返回值
        return { code: CANCELED_CODE } as T
      } else {
        throw thrown
      }
    })
}

export default request
